<template>
  <div></div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      msg: 'Starbucks locations USA'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue